// ============================================================================
// useIsDarkTheme — детерминированный детект тёмной темы по CSS-переменной
// --color-background (SSoT — ThemeLoader). НИКАКИХ флагов dark/light:
// тёмность = сама тема. Используется CodeMirror-редакторами (подсветка
// синтаксиса следует теме платформы: theme="dark"/"light").
// ============================================================================

import { useEffect, useState } from 'react';

function readBackgroundLuminance(): number {
  try {
    const bg = getComputedStyle(document.documentElement).getPropertyValue('--color-background').trim();
    const hex = bg.startsWith('#') ? bg : `#${bg}`;
    if (!/^#[0-9a-fA-F]{6}$/.test(hex)) return 1; // не распарсилось — считаем светлой
    const n = parseInt(hex.slice(1), 16);
    const r = (n >> 16) & 0xff;
    const g = (n >> 8) & 0xff;
    const b = n & 0xff;
    // Относительная яркость (WCAG): тёмный фон → luminance < 0.5
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  } catch {
    return 1;
  }
}

export function useIsDarkTheme(): boolean {
  const [isDark, setIsDark] = useState<boolean>(() => readBackgroundLuminance() < 0.5);

  useEffect(() => {
    const update = () => setIsDark(readBackgroundLuminance() < 0.5);
    // ThemeLoader пишет CSS-переменные в <style> (head) — MutationObserver
    // реагирует на смену темы без таймеров-поллинга (событийная модель).
    const observer = new MutationObserver(update);
    observer.observe(document.head, { childList: true, subtree: true, attributes: true });
    window.addEventListener('hydra:theme-changed', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('hydra:theme-changed', update);
    };
  }, []);

  return isDark;
}
